import type { GetServerSidePropsContext } from "next";

import { loadPageWithGlobal } from "@shared/api";

import { getShopPage } from "@/_pages/shop/api";
import type { PageType, ShopListType } from "@/_pages/shop/model";
import { ShopPage } from "@/_pages/shop/ui";

type PageProps = {
  cms: {
    page: PageType;
    list: ShopListType;
  };
};

const Page = (props: PageProps) => {
  const {
    cms: { list, page },
  } = props;

  return <ShopPage content={list} page={page} />;
};

export async function getServerSideProps({ res }: GetServerSidePropsContext) {
  return await loadPageWithGlobal(
    async () => {
      return {
        ...(await getShopPage()),
      };
    },
    { res },
  );
}

export default Page;
